exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-d8c87b7a]{font-size:24px;border-bottom:1px solid #e6e6e6;padding-bottom:10px;margin-bottom:30px}.flex[data-v-d8c87b7a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
